import React, { useState, useEffect } from "react";
import { Settings } from "./components/settings";
import { AccountDetails } from "./components/accountDetails";
import { Orders } from "./components/Orders";
import { ManageAddress } from "./components/ManageAddress";
import ResponsiveAppBar from "../../../layouts/navbar";
import { ProductTypes } from "../../public/landingPage/components/productTypes";
import { Footer } from "../../../layouts/footer";
import CustomDialog from "../../../components/custom/dialog";
import { LogoutModal } from "../../../layouts/components/LogoutModal";
import { WishList } from "./components/WishList";
import { useAppSelector } from "../../../../app/redux/hooks";
import { useNavigate } from "react-router-dom";
import { ReferAndEarn } from "./components/ReferAndEarn";

const ProfilePage = () => {
  const [activeComponent, setActiveComponent] = useState("Orders");
  const [modalType, setModalType] = React.useState("");
  const profileSectionprops = useAppSelector(
    (state) => state.locationState.profileSection
  );
  const navigate = useNavigate();
  useEffect(() => {
    if (profileSectionprops) {
      setActiveComponent(profileSectionprops);
    }
  }, [profileSectionprops]);

  const profileDataState: any = useAppSelector(
    (state) => state.ProfileState?.profileData?.data
  );
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const renderComponent = () => {
    switch (activeComponent) {
      case "Settings":
        return <Settings />;
      case "AccountDetails":
        return <AccountDetails />;
      case "Orders":
        return <Orders />;
      case "ManageAddress":
        return <ManageAddress />;
      case "Wishlist":
        return <WishList />;
      case "ReferAndEarn":
        return <ReferAndEarn />;
      default:
        return <Settings />;
    }
  };

  const onOpenModal = (type: string) => {
    setModalType(type);
  };
  const onCloseModal = () => {
    setModalType("");
  };
  return (
    <>
      <div id="wrapper">
        <ResponsiveAppBar />
        <ProductTypes />

        <div className="tf-breadcrumb">
          <div className="container">
            <div className="tf-breadcrumb-wrap d-flex justify-content-between flex-wrap align-items-center">
              <div className="tf-breadcrumb-list">
                <a className="text" onClick={() => navigate("/")}>
                  Home
                </a>
                <i className="icon icon-arrow-right"></i>
                <span className="text">My Account</span>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="tf-breadcrumb profile-top">
            <div className="container px-4">
              {profileDataState?.first_name && profileDataState?.last_name && (
                <h5 className="mb_10">
                  {profileDataState.first_name +
                    " " +
                    profileDataState.last_name}
                </h5>
              )}
              {(profileDataState?.phone_number || profileDataState?.email) && (
                <div className="mb_0">
                  <p>
                    {profileDataState?.phone_number && (
                      <strong>{profileDataState.phone_number}</strong>
                    )}
                    {profileDataState?.email && (
                      <span>{" | " + profileDataState.email}</span>
                    )}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>

        <section className="flat-spacing-11">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-12">
                <div className="dropdown mob-v">
                  <button
                    className="tf-btn animate-hover-btn radius-3 w-100 justify-content-center orange-b btn-add-note dropdown-toggle mb-4"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Select Menu
                  </button>
                  <ul
                    className="dropdown-menu w-100"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => setActiveComponent("Orders")}
                      >
                        Orders
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => setActiveComponent("AccountDetails")}
                      >
                        Account Details
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => setActiveComponent("ManageAddress")}
                      >
                        Address
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => setActiveComponent("Wishlist")}
                      >
                        Wishlist
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => setActiveComponent("ReferAndEarn")}
                      >
                        Refer & Earn
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() => setActiveComponent("Settings")}
                        className="dropdown-item"
                      >
                        Settings
                      </a>
                    </li>
                    <li>
                      <a
                        href="#logout"
                        data-bs-toggle="modal"
                        className="dropdown-item"
                      >
                        Logout
                      </a>
                    </li>
                  </ul>
                </div>
                <ul className="my-account-nav mob-h">
                  <li>
                    <a
                      onClick={() => setActiveComponent("Orders")}
                      className={`my-account-nav-item ${
                        activeComponent === "Orders" ? "active" : ""
                      }`}
                    >
                      Orders
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() => setActiveComponent("AccountDetails")}
                      className={`my-account-nav-item ${
                        activeComponent === "AccountDetails" ? "active" : ""
                      }`}
                    >
                      Account Details
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() => setActiveComponent("ManageAddress")}
                      className={`my-account-nav-item ${
                        activeComponent === "ManageAddress" ? "active" : ""
                      }`}
                    >
                      Address
                    </a>
                  </li>
                  {/* commented on 12/02  */}
                  <li>
                    <a
                      onClick={() => setActiveComponent("Wishlist")}
                      className={`my-account-nav-item ${
                        activeComponent === "Wishlist" ? "active" : ""
                      }`}
                    >
                      Wishlist
                    </a>
                  </li>
                  <li>
                    <a
                      className={`my-account-nav-item ${
                        activeComponent === "ReferAndEarn" ? "active" : ""
                      }`}
                      onClick={() => setActiveComponent("ReferAndEarn")}
                    >
                      Refer & Earn
                    </a>
                  </li>
                  <li>
                    <span
                      onClick={() => setActiveComponent("Settings")}
                      className={`my-account-nav-item ${
                        activeComponent === "Settings" ? "active" : ""
                      }`}
                    >
                      Settings
                    </span>
                  </li>
                  <li>
                    <span
                      onClick={() => onOpenModal("logout")}
                      className="my-account-nav-item"
                    >
                      Logout
                    </span>
                  </li>
                </ul>
              </div>

              <div className="col-lg-9">{renderComponent()}</div>
            </div>
          </div>
        </section>
      </div>{" "}
      <CustomDialog
        component={<LogoutModal modalClose={onCloseModal} />}
        title="Logout"
        openDialog={modalType === "logout"}
        handleCloseDialog={onCloseModal}
      />
      <Footer />
    </>
  );
};

export default ProfilePage;
